import z from "zod";
import { PreAnnotateModelTypeEnum, PreAnnotateProviderEnum, } from "../preAnnotateSettings/preAnnotateSettings.schema";
export var AutoAnnotationBatchStatusEnum;
(function (AutoAnnotationBatchStatusEnum) {
    AutoAnnotationBatchStatusEnum["RUNNING"] = "running";
    AutoAnnotationBatchStatusEnum["FINISHED"] = "finished";
})(AutoAnnotationBatchStatusEnum || (AutoAnnotationBatchStatusEnum = {}));
export var AutoAnnotationBatchItemStatusEnum;
(function (AutoAnnotationBatchItemStatusEnum) {
    AutoAnnotationBatchItemStatusEnum["PENDING"] = "pending";
    AutoAnnotationBatchItemStatusEnum["DONE"] = "done";
    AutoAnnotationBatchItemStatusEnum["FAILED"] = "failed";
})(AutoAnnotationBatchItemStatusEnum || (AutoAnnotationBatchItemStatusEnum = {}));
export const AUTO_ANNOTATION_BATCH_MAX_TASKS = 5000;
export const createAutoAnnotationBatchSchema = z.object({
    taskIds: z
        .number()
        .int()
        .positive()
        .array()
        .min(1)
        .max(AUTO_ANNOTATION_BATCH_MAX_TASKS),
});
export const autoAnnotationBatchItemSchema = z.object({
    taskId: z.number(),
    status: z.enum(AutoAnnotationBatchItemStatusEnum),
    error: z.string().nullable(),
});
export const autoAnnotationBatchSchema = z.object({
    id: z.number(),
    provider: z.enum(PreAnnotateProviderEnum),
    modelType: z.enum(PreAnnotateModelTypeEnum),
    modelId: z.number().nullable(),
    status: z.enum(AutoAnnotationBatchStatusEnum),
    total: z.number(),
    done: z.number(),
    failed: z.number(),
    pending: z.number(),
    items: autoAnnotationBatchItemSchema.array(),
    createdAt: z.iso.datetime(),
    finishedAt: z.iso.datetime().nullable(),
});
export const createAutoAnnotationBatchResponseSchema = z.object({
    batch: autoAnnotationBatchSchema,
    skippedAnnotated: z.number(),
    skippedAwaitingReview: z.number(),
});
export const activeAutoAnnotationBatchResponseSchema = z.object({
    batch: autoAnnotationBatchSchema.nullable(),
});
//# sourceMappingURL=auto-annotation-batch.schema.js.map